import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import {
  CssBaseline, CircularProgress, Container, Button, Grid, Box, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  IconButton, Collapse, Typography, Card, CardContent, Accordion,
  AccordionSummary, AccordionDetails, TextField, Chip
} from "@mui/material"
import { withStyles } from "@mui/styles"
import Pagination from '@mui/material/Pagination'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import moment from "moment"
import { injectIntl } from 'react-intl'
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import Footer from '../../components/footer'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import Api from "../../services/api"
import ApiReports from "../../services/apireport"
import ScheduleReportButton from "../../components/report-schedule";
import * as calledsActions from '../../redux/actions/calleds'

class CalledClosingErrorReport extends Component {
  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false
    this.isAdmGlobal = false

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item) => {
      if (item.role.roletype != 3)
        this.isClient = false
      if (item.role.roletype == 0 || item.role.roletype == 1)
        this.isAdm = true
      if (item.role.roletype == 0)
        this.isAdmGlobal = true
    })

    this.state = {
      dateStart: moment().subtract(1, 'months').format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      calledIdFilter: '',
      organizationFilter: 0,
      techinicalTeamFilter: 0,
      statusFilter: 0,
      calledSituationFilter: 1,

      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,

      errorList: [],
      expandedRows: {},

      organizationList: [],
      techinicalTeamList: [],
      statusList: [],
      calledSituationFilterList: [
        { id: 1, name: 'Apenas Ativos' },
        { id: 2, name: 'Apenas Arquivados' }
      ],

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0
    }

    this.changeValues = this.changeValues.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await Promise.all([
      this.getOrganizations(),
      this.getTechinicalTeams(),
      this.getStatuses()
    ])
    this.setState({ loading: false })
  }

  getOrganizations = async () => {
    await Api.get('/organizations/list')
      .then(result => {
        if (result.data.success)
          this.setState({ organizationList: result.data.data })
      })
      .catch(() => {})
  }

  getTechinicalTeams = async () => {
    await Api.get('/techinicalteams/list')
      .then(result => {
        if (result.data.success)
          this.setState({ techinicalTeamList: result.data.data })
      })
      .catch(() => {})
  }

  getStatuses = async () => {
    await Api.get('/statuses')
      .then(result => {
        const source = result && result.data
          ? (result.data.data ? result.data.data : result.data)
          : []
        if (Array.isArray(source)) {
          const statusList = source.map(item => ({
            id: item.id,
            name: item.name || item.namestatus || item.description || `Status ${item.id}`
          }))
          this.setState({ statusList })
        }
      })
      .catch(() => {})
  }

  changeValues = async (stateName, value) => {
    if (value && value.id !== undefined) {
      this.setState({ [stateName]: value.id })
    } else {
      this.setState({ [stateName]: value })
    }
  }

  clearFilters = () => {
    this.setState({
      dateStart: moment().subtract(1, 'months').format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      calledIdFilter: '',
      organizationFilter: 0,
      techinicalTeamFilter: 0,
      statusFilter: 0,
      calledSituationFilter: 1,
      showGrid: false,
      errorList: [],
      expandedRows: {},
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0
    })
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    this.setState({ loading: true })
    await this.fetchReport()
  }

  buildFilterParams = (dateStart, dateEnd) => {
    let params = `startDate=${dateStart}&endDate=${dateEnd}`

    if (this.state.organizationFilter && this.state.organizationFilter !== 0)
      params += `&organizationId=${this.state.organizationFilter}`

    if (this.state.techinicalTeamFilter && this.state.techinicalTeamFilter !== 0)
      params += `&techinicalTeamId=${this.state.techinicalTeamFilter}`

    if (this.state.statusFilter && this.state.statusFilter !== 0)
      params += `&statusId=${this.state.statusFilter}`

    if (this.state.calledIdFilter && this.state.calledIdFilter.trim() !== '')
      params += `&calledId=${this.state.calledIdFilter.trim()}`

    params += `&archived=${this.state.calledSituationFilter === 2}`

    return params
  }

  fetchReport = async () => {
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (moment(dateStart).isAfter(moment(dateEnd))) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: "A data inicial deve ser menor que a data final.",
        loading: false
      })
      return
    }

    await Promise.all([
      this.fetchPaginate(dateStart, dateEnd, 1)
    ])

    this.setState({ showGrid: true, loading: false, scheduleRequest: `/report/called-closing-error/paginate?${this.buildFilterParams(dateStart, dateEnd)}` }) // Agendamento de relatórios
  }

  fetchPaginate = async (dateStart, dateEnd, page) => {
    const params = this.buildFilterParams(dateStart, dateEnd)

    await ApiReports.get(`/report/called-closing-error/paginate?${params}&page=${page}&pageSize=10`)
      .then(result => {
        if (result.data.success) {
          this.setState({
            errorList: result.data.data,
            count: result.data.count,
            page
          })
          this.setPagination(result.data.count, page)
        }
      })
      .catch(err => {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors
            ? err.response.data.errors[0]
            : "Erro ao buscar relatorio de erros de encerramento."
        })
      })
  }

  onChangePaginate = (e, page) => {
    this.setState({ loading: true })
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')
    this.fetchPaginate(dateStart, dateEnd, page).then(() => {
      this.setState({ loading: false })
    })
  }

  setPagination = (count, page) => {
    const totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        this.setState({
          pageStart: 1,
          pageEnd: count < 10 ? count : 10
        })
      } else {
        const pageStart = ((page - 1) * 10) + 1
        this.setState({
          pageStart,
          pageEnd: count >= page * 10 ? page * 10 : count
        })
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0, pageStart: 0, pageEnd: 0 })
    }
  }

  toggleRow = (id) => {
    this.setState(prev => ({
      expandedRows: { ...prev.expandedRows, [id]: !prev.expandedRows[id] }
    }))
  }

  closeNotification = () => {
    this.setState({ openNotification: false })
  }

  exportExcel = async () => {
    this.setState({ loading: true })
    try {
      const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
      const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

      if (moment(dateStart).isAfter(moment(dateEnd))) {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: "A data inicial deve ser menor que a data final.",
          loading: false
        })
        return
      }

      let calledId = null
      if (this.state.calledIdFilter && this.state.calledIdFilter.trim() !== '') {
        const parsedCalledId = Number(this.state.calledIdFilter.trim())
        if (Number.isNaN(parsedCalledId) || parsedCalledId <= 0) {
          this.setState({
            openNotification: true,
            notificationVariant: "error",
            notificationMessage: "Informe um Id Chamado valido.",
            loading: false
          })
          return
        }
        calledId = parsedCalledId
      }

      const payload = {
        DateStart: dateStart,
        DateEnd: dateEnd,
        CalledId: calledId,
        OrganizationId: this.state.organizationFilter && this.state.organizationFilter !== 0 ? this.state.organizationFilter : null,
        TechinicalTeamId: this.state.techinicalTeamFilter && this.state.techinicalTeamFilter !== 0 ? this.state.techinicalTeamFilter : null,
        StatusId: this.state.statusFilter && this.state.statusFilter !== 0 ? this.state.statusFilter : null,
        Archived: this.state.calledSituationFilter === 2
      }

      const calledClosingErrorExportEndpoint = '/report/called-closing-error/excell/new'
      const response = await ApiReports.post(calledClosingErrorExportEndpoint, payload)
      if (response.data && response.data.success) {
        this.setState({
          openNotification: true,
          notificationVariant: "success",
          notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")"
        })
      } else {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: response && response.data && response.data.errors && response.data.errors[0]
            ? response.data.errors[0]
            : this.props.intl.formatMessage({ id: "process.error" })
        })
      }
    } catch (error) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: error && error.response && error.response.data && error.response.data.errors && error.response.data.errors[0]
          ? error.response.data.errors[0]
          : this.props.intl.formatMessage({ id: "process.error" })
      })
    }
    this.setState({ loading: false })
  }

  renderMainTable() {
    const { errorList } = this.state

    return (
      <Paper elevation={2} style={{ borderRadius: 12, overflow: 'hidden', marginBottom: 20 }}>
        <Box style={{ padding: '16px 20px', backgroundColor: '#3F51B4', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
            Chamados com erro no encerramento
          </Typography>
          <Typography variant="caption" style={{ opacity: 0.8, color: 'inherit' }}>
            {this.state.count} registro(s)
          </Typography>
        </Box>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow style={{ backgroundColor: '#3F51B4' }}>
                <TableCell style={{ fontWeight: 700, width: 30, color: '#fff' }} />
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>ID Chamado</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Data Erro</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Chamado</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Organizacao</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Time</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Status</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Solicitante</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Responsavel</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Mensagem</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {errorList.map((item, idx) => (
                <React.Fragment key={item.id}>
                  <TableRow hover style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                    <TableCell>
                      <IconButton size="small" onClick={() => this.toggleRow(item.id)}>
                        {this.state.expandedRows[item.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </IconButton>
                    </TableCell>
                    <TableCell style={{ fontWeight: 700 }}>#{item.id}</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                      {item.errorat ? moment(item.errorat).format('DD/MM/YYYY HH:mm:ss') : '-'}
                    </TableCell>
                    <TableCell style={{ maxWidth: 280 }}>
                      <Typography style={{ fontSize: 12, color: '#475569' }} noWrap>{item.title || '-'}</Typography>
                    </TableCell>
                    <TableCell>{item.organizationname || '-'}</TableCell>
                    <TableCell>{item.techinicalteamname || '-'}</TableCell>
                    <TableCell>{item.statusname || '-'}</TableCell>
                    <TableCell>{item.requestingusername || '-'}</TableCell>
                    <TableCell>
                      {item.assignedusername
                        ? item.assignedusername
                        : <Chip size="small" label="Nao atribuido" style={{ backgroundColor: '#fee2e2', color: '#991b1b', fontWeight: 600 }} />
                      }
                    </TableCell>
                    <TableCell style={{ maxWidth: 280, color: '#991b1b' }}>
                      <Typography style={{ fontSize: 12 }} noWrap>
                        {item.messageerroronasynchronousclosingcalled || '-'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: this.state.expandedRows[item.id] ? undefined : 'none' }} colSpan={10}>
                      <Collapse in={this.state.expandedRows[item.id]} timeout="auto" unmountOnExit>
                        <Box style={{ margin: '12px 0', padding: 16, backgroundColor: '#f8fafc', borderRadius: 8 }}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                              <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Data Abertura</Typography>
                              <Typography style={{ fontSize: 13 }}>
                                {item.openingdate ? moment(item.openingdate).format('DD/MM/YYYY HH:mm:ss') : '-'}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Email do Solicitante</Typography>
                              <Typography style={{ fontSize: 13 }}>{item.requestinguseremail || '-'}</Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Erro no Encerramento Async</Typography>
                              <Typography style={{ fontSize: 13 }}>{item.haserroronasynchronousclosingcalled ? 'Sim' : 'Nao'}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Mensagem completa do erro</Typography>
                              <Typography style={{ fontSize: 13, color: '#991b1b', whiteSpace: 'pre-wrap' }}>
                                {item.messageerroronasynchronousclosingcalled || '-'}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
              {errorList.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10} align="center" style={{ padding: 40, color: '#94a3b8' }}>
                    Nenhum chamado com erro de encerramento no periodo informado.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    )
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props

    if (!this.isAdmGlobal) {
      const l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    if (Api == null) {
      const l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card>
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      Relatorio de Erros de Encerramento de Chamado
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <form name='calledClosingErrorReportForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>Filtros</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container style={{ marginBottom: 20 }} spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker
                        label="Data Inicial"
                        name='dateStart'
                        stateName='dateStart'
                        changeDate={this.changeValues}
                        currentDate={this.state.dateStart}
                        fullWidth={true}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker
                        label="Data Final"
                        name='dateEnd'
                        stateName='dateEnd'
                        changeDate={this.changeValues}
                        currentDate={this.state.dateEnd}
                        fullWidth={true}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete
                        label="Organizacao"
                        options={this.state.organizationList}
                        stateName='organizationFilter'
                        changeSelect={this.changeValues}
                        selected={this.state.organizationList.find(item => item.id === this.state.organizationFilter) || { id: 0, name: '' }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete
                        label="Time Tecnico"
                        options={this.state.techinicalTeamList}
                        stateName='techinicalTeamFilter'
                        changeSelect={this.changeValues}
                        selected={this.state.techinicalTeamList.find(item => item.id === this.state.techinicalTeamFilter) || { id: 0, name: '' }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete
                        label="Status"
                        options={this.state.statusList}
                        stateName='statusFilter'
                        changeSelect={this.changeValues}
                        selected={this.state.statusList.find(item => item.id === this.state.statusFilter) || { id: 0, name: '' }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete
                        label="Situacao do Chamado"
                        options={this.state.calledSituationFilterList}
                        stateName='calledSituationFilter'
                        changeSelect={this.changeValues}
                        selected={this.state.calledSituationFilterList.find(item => item.id === this.state.calledSituationFilter) || this.state.calledSituationFilterList[0]}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        label="Id Chamado"
                        value={this.state.calledIdFilter}
                        onChange={(e) => this.changeValues('calledIdFilter', e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Grid container style={{ marginBottom: 10 }}>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button type='submit' fullWidth variant='contained' color='secondary'>
                    Filtrar
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button fullWidth variant='contained' color='secondary' onClick={this.clearFilters}>
                    Limpar filtros
                  </Button>
                </Grid>
                {this.state.showGrid && (
                  <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                    <Button fullWidth variant='contained' color='secondary' onClick={this.exportExcel}>
                      Exportar Excel
                    </Button>
                  </Grid>
                )}
{this.state.showGrid && this.state.scheduleRequest && <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
  <ScheduleReportButton reportKey="called-closing-error" request={this.state.scheduleRequest} color="secondary" />
</Grid>}
              </Grid>
            </form>

            {this.state.showGrid && (
              <>
                <Box style={{ marginTop: 32 }}>
                  {this.renderMainTable()}
                </Box>

                <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                  <Grid item xs={12} md={3}>
                    <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                    {this.state.pageStart} a {this.state.pageEnd} de {this.state.count} registro(s)
                  </Grid>
                </Grid>
              </>
            )}

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

CalledClosingErrorReport.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(CalledClosingErrorReport)))
